import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { Reveal } from './Reveal';
export function PainPoints() {
  return <section className="w-full bg-sand py-16 sm:py-24" aria-labelledby="dolor-title" data-id="element-193" data-mp="2lpeuecmv95yb">
      <div className="mx-auto max-w-6xl px-6" data-id="element-194" data-mp="26y619tjr92gf">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1fr)] lg:gap-20" data-id="element-195" data-mp="2bwzdlinb2nf0">
          <Reveal data-id="element-196" data-mp="1xxzsum2wyso4">
            <h2 id="dolor-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-197" data-mp="1xwomqflzx8tu">
              Tu cocina ya tiene lo que la gente quiere comer.
              <span className="block text-mint-700" data-id="element-198" data-mp="1o03elleojhls">Hazla destacar y empieza a ganar con cada pedido.</span>
            </h2>
            <p className="mt-6 max-w-md text-lg text-ink-soft" data-id="element-199" data-mp="1szg30al78wqh">
              Muchos caterings grandes piden un mínimo de invitados, así que los pedidos chicos suelen quedarse sin atender.
            </p>
            <p className="mt-8 font-display text-2xl text-ink sm:text-[1.75rem]" data-id="element-200" data-mp="3nbd1gni272v1">
              Sabes cocinar. Lo que falta es el sistema para venderlo sin perder dinero ni tiempo.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-201" data-mp="1u1bvndpif5zz">
            <ul className="divide-y divide-cream-line border-y border-cream-line" data-id="element-202" data-mp="27sz0i1xipmud">
              {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-5" data-id="element-203" data-mp="23rn7dmffqjhf">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-terra-light text-terra-dark" aria-hidden="true" data-id="element-204" data-mp="23trcg7p2loja">
                    <XIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-205" data-mp="1b417ao5f1wzb" />
                  </span>
                  <span className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-206" data-mp="1p3k1se5b19t5">
                    {point}
                  </span>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}